import { PublicClientApplication } from "@azure/msal-browser";
import { env } from "configs/EnvironmentConfig";
import React from "react";
import ReactDOM from "react-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import App from "./App";
import { msalConfig } from "./auth/authConfig";
import "./i18n";
import * as serviceWorker from "./serviceWorker";
import store from "./store";

const msalInstance = new PublicClientApplication(msalConfig);
const app = (
  <ToastProvider placement="top-right">
    <Provider store={store}>
      <BrowserRouter>
      {env.API_ENABLE_CAPTCHA === "ENABLE" ?
        <GoogleReCaptchaProvider reCaptchaKey={env.API_RECAPTCHA_V3_KEY}>
          <App />
        </GoogleReCaptchaProvider>:<App />
      }
      </BrowserRouter>
    </Provider>
  </ToastProvider>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
